import React from 'react';
import useTranslate from '@src/i18n/useTranslate';
import { WarningContainer, WarningIcon, WarningText } from './styles';
import { FiAlertCircle } from 'react-icons/fi';

const CurrencyWarning = () => {
  const { i18n } = useTranslate();

  return (
    <WarningContainer>
      <WarningIcon>
        <FiAlertCircle size={24} />
      </WarningIcon>
      <WarningText>{i18n('currency_warning_message')}</WarningText>
    </WarningContainer>
  );
};

export default CurrencyWarning;
